// extracted by mini-css-extract-plugin
export default {"banner":"TopBanner_banner__znBeu","message":"TopBanner_message__jdznv"};